import { IAuthToken } from './models/auth';
import { account } from './resources/account';
import { acknowledgement } from './resources/acknowledgement';
import { audioVisitation } from './resources/audioVisitation';
import { auth } from './resources/auth';
import { block } from './resources/block';
import { cdr } from './resources/cdr';
import { commissary } from './resources/commissary';
import { condition } from './resources/conditions';
import { configuration } from './resources/configuration';
import { email } from './resources/email';
import { eventNotification } from './resources/eventNotification';
import { facility } from './resources/facility';
import { facilityUser } from './resources/facilityUser';
import { housingUnit } from './resources/housingUnit';
import { inmateAccount } from './resources/inmateAccount';
import { inmateContact } from './resources/inmateContact';
import { inmateDevice } from './resources/inmateDevice';
import { inmateNotification } from './resources/inmateNotification';
import { inmateRequest } from './resources/inmateRequest';
import { inmates } from './resources/inmates';
import { itds } from './resources/itds';
import { location as locationResource } from './resources/location';
import { mobileDevice } from './resources/mobileDevice';
import { outsideParty } from './resources/outsideParty';
import { personSearch } from './resources/personSearch';
import { phoneCard } from './resources/phoneCard';
import { privateNumber } from './resources/privateNumber';
import { recordingBatch } from './resources/recordingBatch';
import { station } from './resources/station';
import { textMessage } from './resources/textMessage';
import { visitation } from './resources/visitation';
import { visitationPending } from './resources/visitationPending';
import { voicemail } from './resources/voicemail';
import { website } from './resources/website';
import ApiService from './services/api_service';
import config from './services/config';
import connectServerService from './services/connect_server_service';

const siteApi = new ApiService(config.api.url, 'site');
const centralApi = new ApiService(
  config.centralApi?.url || 'https://api.reliancetelephone.com',
  'central'
);
let accessToken = null;

const resources = {
  setToken: (token) => {
    // This method will be called from the auth reducer when either site or central API refresh the token, so the other instance will get it as well
    accessToken = token;
    siteApi.setToken(accessToken);
    centralApi.setToken(accessToken);

    // Connect to Connect Server if configured
    if (token && config.connectServer && config.connectServer.url) {
      connectServerService.open();
    }
  },
  getToken: async (): Promise<IAuthToken> => {
    if (siteApi.isTokenExpired()) {
      return siteApi.refreshToken();
    }
    return Promise.resolve(accessToken);
  },
  getCentralGetResource<FilterType, ResponseType>(url: string) {
    return (params: Partial<FilterType>): Promise<ResponseType> => {
      return centralApi.get(url, { params });
    };
  },
  getSiteGetResource<FilterType, ResponseType>(url: string) {
    return (params: Partial<FilterType>): Promise<ResponseType> => {
      return siteApi.get(url, { params });
    };
  },

  account: account(centralApi),
  acknowledgement: acknowledgement(centralApi),
  audioVisitation: audioVisitation(siteApi),
  auth: auth(siteApi),
  block: block(centralApi),
  condition: condition(centralApi),
  cdr: cdr(siteApi, () => accessToken),
  commissary: commissary(centralApi, () => accessToken),
  configuration: configuration(siteApi),
  email: email(centralApi),
  eventNotification: eventNotification(centralApi),
  facility: facility(centralApi),
  facilityUser: facilityUser(centralApi),
  housingUnit: housingUnit(centralApi),
  inmateAccount: inmateAccount(siteApi, centralApi),
  inmateContact: inmateContact(siteApi, centralApi),
  inmateDevice: inmateDevice(siteApi),
  inmateNotification: inmateNotification(centralApi),
  inmateRequest: inmateRequest(centralApi, () => accessToken),
  inmates: inmates(siteApi, centralApi, () => accessToken),
  itds: itds(siteApi),
  location: locationResource(centralApi),
  mobileDevice: mobileDevice(siteApi),
  outsideParty: outsideParty(siteApi, () => accessToken),
  personSearch: personSearch(centralApi),
  phoneCard: phoneCard(centralApi),
  privateNumber: privateNumber(centralApi),
  recordingBatch: recordingBatch(siteApi, () => accessToken),
  station: station(siteApi),
  textMessage: textMessage(siteApi, centralApi, () => accessToken),
  visitation: visitation(siteApi, () => accessToken),
  visitationPending: visitationPending(siteApi),
  voicemail: voicemail(siteApi, () => accessToken),
  website: website(centralApi)
};

export default resources;
